import { create } from 'zustand';

type Status = 'idle' | 'loading' | 'empty' | 'error';

interface BaseStore<T> {
  data: T;
  load: boolean;
  setData: (data: T) => void;
  setLoad: (status: boolean) => void;
  updateData: (data: Partial<T>) => void;
  fullLoad: () => void;
  reset: () => void;
  status: Status;
  setStatus: (status: Status) => void;
}

export function createDataStore<T>(initialData?: T) {
  return create<BaseStore<T>>()(
    (set, get) => ({
      data: initialData ?? ({} as T),
      load: false,
      status: 'empty' as Status,
      setData: (data: T) => {
        const { reset } = get();
        reset();
        set({ data, load: !!data, status: data ? 'idle' : 'empty' });
      },
      setStatus: (status: Status) => {
        set({ status });
      },
      updateData: (data: Partial<T>) => {
        set((state) => ({
          data: {
            ...state.data,
            ...data,
          },
        }));
      },
      setLoad: (status: boolean) => set({ load: status }),
      fullLoad: () => {
        set({ load: false, status: 'empty' });
      },
      reset: () => {
        set({ load: false, status: 'empty' });
      },
    }))
  ;
}
